import {DateTimeInput} from '@flinkit/ra-form-layout'
import {
  DateTimeInputProps,
} from '@flinkit/ra-form-layout/src/forms/DatePickers/DateTimeInput'
import {FC} from 'react'
import {useLocale} from 'react-admin'
import {makeStyles} from 'tss-react/mui'

const ExtendedDateTimeInput: FC<DateTimeInputProps> = ({...props}) => {
  const {classes: styles} = useStyles({})
  const {slotProps} = props
  const locale = useLocale()
  return (
    <DateTimeInput
      ampm={locale === 'en'}
      mask={locale === 'en' ? undefined : 'dd/MM/yyyy hh:mm'}
      {...props}
      slotProps={{
        ...slotProps,
        popper: {
          ...slotProps?.popper,
          className: styles.popperDatePicker,
        },
      }}
    />
  )
}

const useStyles = makeStyles<any>()(theme => ({
  popperDatePicker: {
    '& .MuiButton-textPrimary': {
      color: theme.palette.info.main,
    },
    '& .MuiMultiSectionDigitalClockSection-item.Mui-selected': {
      backgroundColor: theme.palette.info.main,
    },
    '& .MuiPickersDay-root.Mui-selected': {
      backgroundColor: theme.palette.info.main,
    },
  },
}))

export default ExtendedDateTimeInput
